<template>
	<div class="container">
		<el-form ref="form" :inline-message='true' :model="form"  label-width="100px">
			<el-form-item label="运费模板：">
				<el-select :disabled="isDisabled" size='mini' v-model="freight" clearable style="width:120px" @change="get">
					<el-option v-for='(item,index) in freightList' :key='index' :value="item.freighttemplateid" :label='item.freighttemplatename'></el-option>
				</el-select>
			</el-form-item>
			<div v-if='freight !=="" && isShow'>
				<el-form-item label="计费方式：">
					<el-radio-group v-model="form.freighttype">
						<el-radio disabled :label='0'>按重量</el-radio>
						<el-radio disabled :label='1'>按件</el-radio>
					</el-radio-group>
				</el-form-item>
				<div class="table-box">
					<el-table
						class="grid-content"
						:data="areaTableData"
						size='mini'
						border
						stripe
						:height="tableHeight">
						<el-table-column
							prop="areaname"
							label="可配送区域"
							align="center"
							min-width="300">
							<template slot-scope="scope">
								<el-button size='mini' @click="editTree(scope.row.id)" style="width:300px;overflow:hidden;padding:0px;height:16px" type='text'>{{scope.row.areaname}}</el-button>
							</template>
						</el-table-column>
						<el-table-column
							prop="freight"
							v-if="form.freighttype === 0"
							label="按重（kg）"
							align="center"
							width="120">
						</el-table-column>
						<el-table-column
							prop="freight"
							v-else
							label="按件（个）"
							align="center"
							width="120">
						</el-table-column>
						<el-table-column
							prop="freightamount"
							label="运费（元）"
							align="center"
							width="120">
						</el-table-column>
						<el-table-column
							prop="freightstep"
							v-if="form.freighttype  === 0"
							label="每增加（kg）"
							align="center"
							width="120">
						</el-table-column>
						<el-table-column
							prop="freightstep"
								v-else
							label="每增加（个）"
							align="center"
							width="120">
						</el-table-column>
						<el-table-column
							prop="freightstepamount"
							label="增加运费（元）"
							align="center"
							width="120">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="btn-box" v-if="!isDisabled">
				<el-button size='mini' class="fx-big-btn" plain @click="cancel">取消</el-button>
				<el-button size='mini' class="fx-big-btn" plain type="primary" @click="submitForm('form')">保存</el-button>
			</div>
        </el-form>
        <el-dialog
            title="选择配送区域"
            :visible.sync="showTree"
            class="dialog-title"
            width="800px"
            :close-on-click-modal="false">
            <tree @dialogClose="dialogClose" :disabled='true' :treeId='treeId' :freightId='id' :isAdd='addTree' v-if="showTree"/>
        </el-dialog>
    </div>
</template>

<script>
import tree from '@/components/freight/tree.vue'

export default {
	name: 'edit',
	components: {
		tree
	},
	data () {
		return {
			isShow: false,
			AuthorityList: {
				'02_0001_0001_00': true,
				'02_0001_0002_00': true,
				'02_0001_0003_00': true,
				'02_0001_0004_00': true,
				'02_0001_0005_00': true,
				'02_0001_0006_00': true,
				'02_0001_0007_00': true,
				'02_0001_0008_00': true
			},
			isDisabled: true,
			showTree: false,
			areaTableData: [],
			tableHeight: '100%',
			samedayflag: false,
			totalCount: 0,
			targettype: 1,
			week: [],
			freight: '',
			freightList: [],
			selfpickTimes: [],
			buyerselfpickflag: false,
			id: '',
			form: {
				deliveryWay: [0],
				sendamount: 0,
				name: '',
				templatetype: 0,
				freighttype: 0
			}
		}
	},
	created () {
		this.getAuthority('02_0001_0000_00')
		this.getFreightList()
	},
	methods: {
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let add = window.sessionStorage.getItem('goodsAdd')
					if (add === 'true') {
						if (this.AuthorityList['02_0001_0002_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['02_0001_0001_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		cancel () {
			this.freight = null
			this.isShow = false
			this.getFreightList()
		},
		submitForm (formName) {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				freightTemplateid: this.freight
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/freighttemplate/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getFreightList () {
			let params = {
				id: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/freighttemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.freightList = res.data
					if (res.data.length > 0) {
						if (res.data[0].bindflag === 1) {
							this.freight = res.data[0].freighttemplateid
							this.$nextTick(() => {
								this.get()
							})
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		get () {
			let params = {
				id: this.freight
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.isShow = true
					// selfpickflag =1 开启自提
					if (res.data.detail.selfpickflag === 0) {
						this.form.deliveryWay = [0]
					} else {
						this.sftid = res.data.selfpickData.id
						this.form.deliveryWay = [0, 1]
						this.buyerselfpickflag = res.data.selfpickData.buyerselfpickflag
						if (this.buyerselfpickflag) {
							this.samedayflag = res.data.selfpickData.samedayflag
							this.week = res.data.selfpickData.week
							let list = res.data.selfpickData.selfpickTimes
							let arr = []
							for (let i = 0; i < list.length; i++) {
								let a = {
									val: [list[i].startdate, list[i].enddate]
								}
								arr.push(a)
							}
							this.selfpickTimes = arr
						}
					}
					this.id = res.data.detail.id
					this.form.sendamount = this.$fxUtils.toFixedSHW(res.data.detail.sendamount, 2)
					this.areaTableData = res.data.areaList
					this.form.templatetype = res.data.detail.templatetype
					this.form.freighttype = res.data.detail.freighttype
					this.form.name = res.data.detail.name
					this.targettype = res.data.targettype
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		dialogClose () {
			this.showTree = false
			this.addTree = false
		},
		editTree (id) {
			this.treeId = id
			this.showTree = true
			this.addTree = false
		}
	}
}
</script>

<style  lang="stylus" scoped>
.container{
	padding-top :10px;
    overflow :auto;
    text-align :left;
    box-sizing :border-box;
    width :100%;
    .input-box{
        width:200px;
    }
    .btn-box{
        margin 10px
    }
    .table-box{
        margin-left: 10px;
        margin-top :10px;
        height :150px;
        .grid-content{
            box-sizing :border-box;
            height :100%;
            overflow-y :auto
        }
        .cell-input{
            width :100px
        }
    }
}

</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
</style>
